/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse, Nav, Tab, Tabs } from "react-bootstrap";
import { toast } from "react-toastify";
import Contacts from "./Contacts";
import AdvancedFilters from "./AdvancedFilters";
import DetectedContacts from "./DetectedContacts";
import ContactSetsList from "./ContactSetsList";
import ContactSetSearch from "./ContactSetSearch";
import ContactsSimpleSearch from "./ContactsSimpleSearch";
import HelpButton from "../HelpContent/HelpButton";
import {
  faMagnifyingGlass,
  faCircleExclamation,
  faMinus,
  faPlus,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import ImportedContactFilesFilters from "../Library/ImportedContactFilesFilters";
import BroadcastImportContacts from "../Broadcast/BroadcastImportContacts";
import ImportContactsModal from "../Broadcast/ImportContactsModal";
import WhiteButton from "../Common/WhiteButton";
import ImportIcon from "../../assets/icons/icon_save-01.svg2";
import { setCurrentModal } from "../store/slices/modalsSlice";
import { useDispatch } from "react-redux";
import MyIcon from "../Common/MyIcon";

export default function ContactSetEditor({
  isRuntimeContacts,
  contactSet,
  setContactSet,
  sendList,
  setSendList,
  contactSets,
  setContactSets,
  ignoredContactSets,
  setIgnoredContactSets,
  initialSearchType,
  hideFilters,
  sendListOptions,
  setTotal,
  showFileImportOption,
  importedFile,
  setFile,
  headers,
  filterErrors = [],
  showFilterErrors = false,
  highlighChannelsIfNotAvailable = undefined,
  onChangeDataSource = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [simpleFilter, setSimpleFilter] = useState([
    // search
    {
      values: [""],
      is_or: false,
      fields: [],
      formats: ["card", "primary"],
      order: 0,
      operator: "prefix",
    },
    // status
    {
      fields: ["status"],
      formats: [],
      isOr: false,
      offset: "0",
      offsetFrom: "fixed",
      offsetType: "positive",
      offsetUnit: "day",
      operator: "is",
      order: 0,
      thread: "CurrentThread",
      timeZone: "",
      timeZoneFrom: "fixed",
      valueId: "",
      valueType: "fixed",
      values: ["active"],
    },
  ]);
  const [fileFilters, setFileFilters] = useState({ status: "processed" });
  const [sendListFilter, setSendListFilter] = useState([]);
  const [searchType, setSearchType] = useState(
    initialSearchType || (contactSet.type === "dynamic" ? "advanced" : "simple")
  );
  const [showSendListSearch, setShowSendListSearch] = useState(false);

  useEffect(() => {
    if (contactSet.type === "dynamic") {
      setSearchType("advanced");
    }
  }, [contactSet.type]);

  const [csSearch, setCsSearch] = useState("");
  const [csType, setCsType] = useState("");
  const [orderBy, setOrderBy] = useState("edited");
  const [forceRefresh, setForceRefresh] = useState(new Date().toLocaleString());

  const dispatch = useDispatch();
  const setContactSetModalData = (d) => {
    dispatch(setCurrentModal({ modal: "contactSet", data: d }));
  };

  return (
    <>
      <div className="mb-4">
        {contactSet.type !== "dynamic" && (
          <div className="bg-colored-reverse p-3 rounded-3 d-flex flex-wrap align-items-end mb-3 gap-2">
            <div className="">
              <label className="form-label text-nowrap fw-bold text-white p-2">
                Data source
              </label>
              <Input
                inputType="select"
                options={[
                  ...(contactSet.type !== "dynamic"
                    ? [
                        {
                          value: "simple",
                          label: `Select contacts manually ${
                            isRuntimeContacts && sendList.add?.length > 0
                              ? `(${sendList.add.length})`
                              : ""
                          }`,
                        },
                      ]
                    : []),
                  ...(!hideFilters
                    ? [
                        {
                          value: "advanced",
                          label: `${
                            isRuntimeContacts
                              ? "Runtime Filters"
                              : "Filter Contacts"
                          } ${
                            isRuntimeContacts && contactSet?.filters?.length > 0
                              ? `(${contactSet.filters.length})`
                              : ""
                          }`,
                        },
                      ]
                    : []),
                  ...(isRuntimeContacts
                    ? [
                        {
                          value: "contact-sets",
                          label: `Groups ${
                            contactSets?.length > 0
                              ? `(${contactSets.length})`
                              : ""
                          }`,
                        },
                      ]
                    : []),
                  ...(showFileImportOption
                    ? [
                        {
                          value: "file-import",
                          label: `Import contacts from file`,
                        },
                      ]
                    : []),
                ]}
                value={[searchType]}
                onChange={([value]) => {
                  setSearchType(value);
                  onChangeDataSource(value);
                }}
              />
            </div>
            <div className="flex-grow-1" />
            {searchType === "simple" && (
              <ContactsSimpleSearch
                filter={simpleFilter}
                setFilter={setSimpleFilter}
              />
            )}

            {searchType === "contact-sets" && (
              <ContactSetSearch
                search={csSearch}
                setSearch={setCsSearch}
                csType={csType}
                setCsType={setCsType}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
              />
            )}

            {searchType === "file-import" && (
              <>
                <ImportContactsModal
                  button={
                    <span
                      title={"Import file"}
                      className={`btn d-flex align-items-center btn-white rounded-3 p-2`}
                      style={{ minWidth: 200 }}
                    >
                      {<MyIcon Icon={ImportIcon} width={20} className="mx-2" />}
                      <div className="border-end border-tertiary mx-2 align-self-stretch" />
                      <div className="text-start small">
                        <h6 className="fw-bold mb-0">
                          Import file
                          <HelpButton helpKey={"broadcast-import-file"} />
                        </h6>
                      </div>
                    </span>
                  }
                  setFile={(f) => {
                    setForceRefresh(new Date().toLocaleString());
                    setFile(f);
                  }}
                  showImportedFileAfterImport={false}
                />
                <ImportedContactFilesFilters
                  key={forceRefresh}
                  filters={fileFilters}
                  setFilters={setFileFilters}
                />
              </>
            )}
          </div>
        )}
        {searchType === "advanced" && (
          <div className="bg-purple-gradient p-3 rounded-3">
            <label className="form-label text-nowrap fw-bold">
              {isRuntimeContacts ? "Runtime Filters" : "Filter Contacts"}
            </label>
            <AdvancedFilters
              isRuntimeContacts={isRuntimeContacts}
              filters={contactSet?.filters}
              setFilters={(filters) => {
                setContactSet((prev) => ({ ...prev, filters }));
              }}
            />
            {showFilterErrors && filterErrors.length > 0 && (
              <div className="alert alert-danger mt-3 mb-0">
                <FontAwesomeIcon className="me-3" icon={faCircleExclamation} />
                {filterErrors}
              </div>
            )}
          </div>
        )}
      </div>
      {!(searchType === "advanced" && isRuntimeContacts) &&
        searchType !== "file-import" && (
          <div
            className="row m-0 align-items-stretch bg-white rounded-3 p-3"
            style={{ minHeight: 400 }}
          >
            {searchType === "contact-sets" ? (
              <div className="col">
                <div className="h-100 position-relative">
                  <div className="h-100 d-flex flex-column ">
                    <h5 style={{ height: 27 }}>Groups</h5>{" "}
                    <ContactSetsList
                      fullView={false}
                      search={csSearch}
                      csType={csType}
                      orderBy={orderBy}
                      contactSetButton={(cs) =>
                        contactSets.includes(cs.uuid) ? (
                          <button
                            type="button"
                            className="btn btn-outline-danger border-0 btn-sm "
                            onClick={() => {
                              setContactSets?.((prev) =>
                                prev.filter((cuuid) => cuuid !== cs.uuid)
                              );
                              setIgnoredContactSets?.((prev) => [
                                ...new Set([...prev, cs.uuid]),
                              ]);
                            }}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-outline-primary border-0 btn-sm "
                            onClick={() => {
                              setContactSets?.((prev) => [...prev, cs.uuid]);
                              setIgnoredContactSets?.((prev) =>
                                prev.filter((cuuid) => cuuid !== cs.uuid)
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`${
                  contactSet?.type === "dynamic" ? "col" : "col-6"
                }`}
              >
                <div className="h-100 position-relative">
                  <div className="h-100 d-flex flex-column">
                    <h5 style={{ height: 27 }}>Search results</h5>
                    <DetectedContacts
                      filters={simpleFilter}
                      onSaveContacts={(addedContacts) =>
                        setSendList((prev) => ({
                          ...prev,
                          add: [...new Set([...prev.add, ...addedContacts])],
                          remove: prev.remove.filter(
                            (item) =>
                              !addedContacts.some((c) => item.uuid === c.uuid)
                          ),
                        }))
                      }
                    />
                    <div className="flex-grow-1 border border-2 p-1 rounded-1">
                      <Contacts
                        sendListOptions={sendListOptions}
                        fullView={false}
                        filters={
                          searchType === "simple" || isRuntimeContacts
                            ? simpleFilter
                            : contactSet?.filters
                        }
                        useSearchOptions={
                          contactSet?.type === "static" || isRuntimeContacts
                        }
                        ignoreContacts={sendList.add}
                        // includeContacts={!isRuntimeContacts && sendList.remove}
                        contactSet={contactSet}
                        contactSets={contactSets}
                        ignoreSets
                        doNotUseSets={
                          !isRuntimeContacts && sendList.clearStatic
                        }
                        notDraggable={() => contactSet?.type === "dynamic"}
                        onDrop={(contactUuid) => {
                          setSendList((prev) => ({
                            ...prev,
                            add: prev.add.filter(
                              (item) => item !== contactUuid
                            ),
                            remove: [...new Set([...prev.remove, contactUuid])],
                          }));
                        }}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        contactButton={
                          ["fixed", "static"].includes(contactSet?.type) ||
                          isRuntimeContacts
                            ? (c) => (
                                <button
                                  type="button"
                                  title="Add contact"
                                  className="btn btn-outline-primary border-0 btn-sm"
                                  onClick={() =>
                                    setSendList((prev) => ({
                                      ...prev,
                                      add: [...new Set([...prev.add, c.uuid])],
                                      remove: prev.remove.filter(
                                        (item) => item !== c.uuid
                                      ),
                                    }))
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faPlus}
                                    className="btn-link"
                                  />
                                </button>
                              )
                            : null
                        }
                        allContactsButton={
                          ["fixed", "static"].includes(contactSet?.type) ||
                          isRuntimeContacts
                            ? (contacts) => (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary border-0 btn-sm align-baseline"
                                  title="Add all in this page"
                                  style={{ marginTop: -30 }}
                                  disabled={contacts.length === 0}
                                  onClick={() =>
                                    setSendList((prev) => ({
                                      ...prev,
                                      add: [
                                        ...new Set([
                                          ...prev.add,
                                          ...contacts.map((c) => c.uuid),
                                        ]),
                                      ],
                                      remove: prev.remove.filter(
                                        (item) =>
                                          !contacts.some((c) => c.uuid === item)
                                      ),
                                    }))
                                  }
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                </button>
                              )
                            : null
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Send List - only show for static contact types */}
            {contactSet?.type === "static" || isRuntimeContacts ? (
              <div className="col-6">
                <div className="d-flex flex-column h-100">
                  <div className="flex-grow-1 overflow-y-auto overflow-x-hidden d-flex flex-column position-relative">
                    {isRuntimeContacts ? (
                      <h5 style={{ height: 27 }}>Selected contacts</h5>
                    ) : (
                      <h5 style={{ height: 27 }}>Group members</h5>
                    )}
                    <div className="flex-grow-1 border border-2 rounded-1 p-1">
                      <Contacts
                        sendListOptions={sendListOptions}
                        setTotal={setTotal}
                        fullView={false}
                        filters={sendListFilter}
                        useSearchOptions
                        ignoreContacts={!isRuntimeContacts && sendList.remove}
                        includeContacts={sendList.add}
                        contactSet={contactSet}
                        contactSets={contactSets}
                        ignoreSets={false}
                        strictCriteria={
                          isRuntimeContacts || sendList.clearStatic
                        }
                        doNotUseSets={
                          sendList.clearStatic && !isRuntimeContacts
                        }
                        notDraggable={(c) => {
                          if (
                            isRuntimeContacts &&
                            (c.contactSets || []).some((cs) =>
                              contactSets.includes(cs.uuid)
                            )
                          ) {
                            toast.error("You cannot remove group member");
                            return true;
                          }
                          return false;
                        }}
                        onDrop={(contactUuid) => {
                          setSendList((prev) => ({
                            ...prev,
                            add: [...new Set([...prev.add, contactUuid])],
                            remove: prev.remove.filter(
                              (item) => item !== contactUuid
                            ),
                          }));
                        }}
                        contactButton={(c) => {
                          if (contactSet?.type === "dynamic") {
                            return "";
                          }
                          if (
                            isRuntimeContacts &&
                            (c.contactSets || []).some((cs) =>
                              contactSets.includes(cs.uuid)
                            )
                          ) {
                            return (
                              <span>
                                <button
                                  className="btn btn-sm btn-outline-danger border-0 me-1"
                                  title="Remove this group from the selection"
                                  onClick={() => {
                                    setContactSets?.((prev) =>
                                      prev.filter(
                                        (cuuid) =>
                                          !c.contactSets
                                            .map((cs) => cs.uuid)
                                            .includes(cuuid)
                                      )
                                    );
                                    setIgnoredContactSets?.((prev) => [
                                      ...new Set([
                                        ...prev,
                                        ...c.contactSets.map((cs) => cs.uuid),
                                      ]),
                                    ]);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faMinus} />
                                </button>
                                <span title="This contact was selected as part of a group. You need to deselect the group to remove this contact.">
                                  {c.contactSets?.map((cs) => (
                                    <button
                                      className="btn btn-sm border-0 text-bg-secondary me-1"
                                      onClick={() =>
                                        setContactSetModalData({
                                          uuid: cs.uuid,
                                        })
                                      }
                                    >
                                      {cs?.label}
                                    </button>
                                  ))}
                                </span>
                              </span>
                            );
                          }
                          return (
                            <button
                              type="button"
                              className="btn btn-outline-danger border-0 btn-sm"
                              title="Remove contact"
                              onClick={() =>
                                setSendList((prev) => ({
                                  ...prev,
                                  add: prev.add.filter(
                                    (item) => item !== c.uuid
                                  ),
                                  remove: [
                                    ...new Set([...prev.remove, c.uuid]),
                                  ],
                                }))
                              }
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </button>
                          );
                        }}
                        allContactsButton={() => (
                          <button
                            type="button"
                            title="Remove all manually selected"
                            className="btn btn-outline-danger border-0 btn-sm align-baseline"
                            style={{ marginTop: -30 }}
                            onClick={() => {
                              setSendList((prev) => ({
                                ...prev,
                                remove: [],
                                add: [],
                                clearStatic: true,
                              }));
                              setContactSets?.(() => []);
                              setIgnoredContactSets?.(() => []);
                            }}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                        )}
                        highlighChannelsIfNotAvailable={
                          highlighChannelsIfNotAvailable
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}

      {searchType === "file-import" ? (
        <BroadcastImportContacts
          key={importedFile?.uuid || "no-file"}
          importedFile={importedFile}
          setFile={setFile}
          headers={headers}
          filters={fileFilters}
          setFilters={setFileFilters}
        />
      ) : null}

      {loading && (
        <div className="loading-overlay">
          <FontAwesomeIcon icon={faRefresh} spin />
        </div>
      )}
    </>
  );
}
